import config from '@/config';
import fetchWrapper from '@/services/fetchWrapper.service';

export async function getGalleryQr() {
  const { response, data } = await fetchWrapper.get(
    `${config.apis.api.url}/gallery/qr-code/`,
    {
      injectToken: true,
    }
  );

  if (response.status === 404) {
    return null;
  }

  if (!response.ok) {
    throw new Error(data?.error_message || data?.error || 'Unable to load gallery QR code');
  }

  return data;
}

export async function ensureGalleryQr() {
  const { response, data } = await fetchWrapper.post(
    `${config.apis.api.url}/gallery/qr-code/`,
    {
      injectToken: true,
      body: {},
    }
  );

  if (!response.ok) {
    throw new Error(data?.error_message || data?.error || 'Unable to generate gallery QR code');
  }

  return data;
}
